import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setInitialised, setData, setBasepath, setBaseBreadcrumb, setError } from 'src/redux/app/actions';
import { setFilterValues } from 'src/redux/bikes/actions';
import Loader from 'components/_utility/Loader/Loader';
import request from 'helpers/request';
import { resolve } from 'helpers/utilities';
import { initialisedSelector } from 'src/redux/app/selectors';

const Init = ({ contentApiEndpoint, basepath, children }) => {
  const initialised = useSelector(initialisedSelector);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setBasepath(basepath || '/'));

    const fetchData = async () => {
      try {
        const res = await request(contentApiEndpoint);

        dispatch(setData(res.data));
        dispatch(setInitialised());
        dispatch(setFilterValues(res.data.filters));
      } catch (ex) {
        dispatch(setError(ex));
      }
    };

    fetchData();

    const breadcrumbEl = document.querySelector('.breadcrumb');
    if (breadcrumbEl) {
      const linkList = breadcrumbEl.children[0];

      if (linkList) {
        const breadcrumb = Array.from(linkList.children).map((linkListItem, index, linkListChildren) => {
          const url =
            index + 1 === linkListChildren.length
              ? '/' // last item is hopefully configurator link
              : resolve(linkListItem.querySelector('a'), 'href', '#'); // otherwise website link

          return {
            url,
            text: resolve(linkListItem.querySelector('[property="name"]'), 'innerHTML', ''),
            siteLink: index + 1 !== linkListChildren.length,
            home: index === 0, // first link should always be home
          };
        });

        breadcrumbEl.innerHTML = '';

        dispatch(setBaseBreadcrumb(breadcrumb));
      }

      const footerEl = document.querySelector('footer');
      if (footerEl) {
        footerEl.style.display = 'none';
      }
    }

    document.documentElement.style.overflowY = 'auto';
  }, [basepath, contentApiEndpoint, dispatch]);

  if (!initialised) {
    return <Loader />;
  }

  return children;
};

export default Init;
